export const ItemType = {
    LIST_ITEM: 'listItem'
}